import React from 'react';

const LandingHero = ({ t }) => {
  return (
    <section className="px-4 py-12 md:py-20" style={{ backgroundColor: '#F9F9F6' }}>
        <div className="max-w-6xl mx-auto">
          {/* Titular Principal H1 */}
          <div className="text-center mb-8">
            <h1 
              className="text-3xl md:text-5xl lg:text-6xl mb-2 leading-tight"
              style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
              data-testid="hero-title"
            >
              {t('landing.hero.title')}
            </h1>
            <h1 
              className="text-3xl md:text-5xl lg:text-6xl mb-6 leading-tight"
              style={{ fontFamily: "'Patrick Hand', cursive", color: '#27AE60' }}
            >
              {t('landing.hero.titleLine2')}
            </h1>
            
            <p 
              className="text-base md:text-lg max-w-3xl mx-auto leading-relaxed mb-8" 
              style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              data-testid="hero-subtitle"
            >
              {t('landing.hero.subtitle')}
            </p>
          </div>
          
          {/* 3 Tarjetas de Dolor */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            {/* Card 1 */}
            <div className="flex flex-col items-center">
              <div 
                className="w-full rounded-2xl overflow-hidden mb-4"
                style={{ 
                  border: '3px solid #2C2C2C',
                  backgroundColor: '#F9F9F6',
                  boxShadow: '5px 5px 0 rgba(44,44,44,0.1)'
                }}
              >
                <img 
                  src="/hero-torta-deudas.webp" 
                  alt="Saldo disponible" 
                  className="w-full h-48 md:h-56 object-cover"
                  style={{ mixBlendMode: 'multiply' }}
                  loading="lazy"
                />
              </div>
              <p 
                className="text-center text-sm md:text-base px-2"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              >
                {t('landing.hero.card1.text')}
              </p>
            </div>
            
            {/* Card 2 */}
            <div className="flex flex-col items-center">
              <div 
                className="w-full rounded-2xl overflow-hidden mb-4"
                style={{ 
                  border: '3px solid #2C2C2C',
                  backgroundColor: '#F9F9F6',
                  boxShadow: '5px 5px 0 rgba(44,44,44,0.1)'
                }}
              >
                <img 
                  src="/problema-2-gastando.webp" 
                  alt="Gastos ocultos" 
                  className="w-full h-48 md:h-56 object-cover"
                  style={{ mixBlendMode: 'multiply' }}
                  loading="lazy"
                />
              </div>
              <p 
                className="text-center text-sm md:text-base px-2"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              >
                {t('landing.hero.card2.text')}
              </p>
            </div>
            
            {/* Card 3 */}
            <div className="flex flex-col items-center">
              <div 
                className="w-full rounded-2xl overflow-hidden mb-4"
                style={{ 
                  border: '3px solid #2C2C2C',
                  backgroundColor: '#F9F9F6',
                  boxShadow: '5px 5px 0 rgba(44,44,44,0.1)'
                }}
              >
                <img 
                  src="/problema-3-vacio.webp" 
                  alt="Sin dinero" 
                  className="w-full h-48 md:h-56 object-cover"
                  style={{ mixBlendMode: 'multiply' }}
                  loading="lazy"
                />
              </div>
              <p 
                className="text-center text-sm md:text-base px-2"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#E74C3C', fontStyle: 'italic' }}
              >
                {t('landing.hero.card3.text')}
              </p>
            </div>
          </div>
          
          {/* CTA Button */}
          <div className="text-center">
            <button
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 rounded-xl font-bold text-lg md:text-xl transition-all hover:scale-105"
              style={{ 
                backgroundColor: '#27AE60', 
                color: 'white',
                fontFamily: "'Patrick Hand', cursive",
                boxShadow: '5px 5px 0 #2C2C2C',
                border: '3px solid #2C2C2C'
              }}
              data-testid="hero-cta-btn"
            >
              {t('landing.hero.cta')}
            </button>
          </div>
        </div>
      </section>
  );
};

export default LandingHero;
